var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastroOriginal
    ? _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.abaAtiva,
                callback: function($$v) {
                  _vm.abaAtiva = $$v
                },
                expression: "abaAtiva"
              }
            },
            [
              _c("cadastro-uc", { attrs: { dadosJson: _vm.dadosJson } }),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "qualificacao" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Geral  ")
                  ]),
                  _vm.isInformacao
                    ? _c("informacao-desejada", {
                        attrs: {
                          informacaoDesejada:
                            _vm.cadastroOriginal.informacaoDesejada,
                          tipo: _vm.processo.tipo.nome,
                          dataCadastro: _vm.processo.dataCadastro
                        }
                      })
                    : _vm._e(),
                  _vm.isPermuta
                    ? _c("informacoes-qualificacao-permuta", {
                        attrs: {
                          qualificacao: _vm.cadastroOriginal.qualificacao,
                          tipo: _vm.processo.tipo.nome,
                          dataCadastro: _vm.processo.dataCadastro,
                          cadastroOriginal: _vm.cadastroOriginal,
                          compararQualificacaoPermuta:
                            _vm.compararRetificacoes &&
                            _vm.compararRetificacoes.mudouQualificacaoDTO
                        }
                      })
                    : _vm._e(),
                  !_vm.isInformacao && !_vm.isPermuta
                    ? _c("informacao-desejada", {
                        attrs: {
                          informacaoDesejada: _vm.cadastroOriginal,
                          tipo: _vm.processo.tipo.nome,
                          dataCadastro: _vm.processo.dataCadastro,
                          withOutQualificacao: true
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "cadastrante" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Cadastrante  ")
                  ]),
                  !_vm.isAreasPatrimoniais
                    ? _c("informacoes-cadastrante", {
                        attrs: {
                          cadastrante: _vm.cadastrante,
                          tipoProcesso: _vm.tipoProcesso,
                          compararCadastante:
                            _vm.compararRetificacoes &&
                            _vm.compararRetificacoes.mudouCadastranteDTO
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.cadastrante.membrosComunidade, function(membro) {
                    return _c(
                      "div",
                      [
                        _vm.isMembrosComunidade
                          ? _c("informacoes-cadastrante", {
                              attrs: {
                                cadastrante: membro,
                                isOnerosoGroup: _vm.isOnerosoGroup,
                                tipoProcesso: _vm.tipoProcesso,
                                dadosJson: _vm.dadosJson
                              }
                            })
                          : _vm._e(),
                        _c("app-divider")
                      ],
                      1
                    )
                  }),
                  _vm.isAreasPatrimoniais
                    ? _c("informacoes-cadastrante-areas-patrimoniais", {
                        attrs: {
                          cadastroOriginal: _vm.cadastroOriginal,
                          compararCadastranteAreasPatrimoniais:
                            _vm.compararRetificacoes &&
                            _vm.compararRetificacoes.mudouCadastranteDTO
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.documentos &&
                  _vm.cadastrante.documentos.length > 0
                    ? _c("listagem-documentos", {
                        attrs: {
                          documentos: _vm.cadastrante.documentos,
                          protocoloCadastroOriginal:
                            _vm.cadastroOriginal.protocolo,
                          ownerDocumento: "CADASTRANTE",
                          compararDocumentos:
                            _vm.compararRetificacoes &&
                            _vm.compararRetificacoes.mudouCadastranteDTO,
                          versaoCadastro: _vm.versaoCadastro
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
              !_vm.isReurbColetivo
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "interessado" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("Interessado  ")
                      ]),
                      !_vm.isAreasPatrimoniais
                        ? _c("informacoes-interessado", {
                            attrs: {
                              interessado: _vm.interessado,
                              idCadastro: this.processo.numeroProtocolo,
                              compararInteressado:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouInteressadoDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isAreasPatrimoniais
                        ? _c("informacoes-interessado-areas-patrimoniais", {
                            attrs: {
                              interessado: _vm.interessado,
                              compararInteressadoAreasPatrimoniais:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouInteressadoDTO
                            }
                          })
                        : _vm._e(),
                      _vm.interessado.documentos &&
                      _vm.interessado.documentos.length > 0
                        ? _c("listagem-documentos", {
                            attrs: {
                              documentos: _vm.interessado.documentos,
                              protocoloCadastroOriginal:
                                _vm.cadastroOriginal.protocolo,
                              ownerDocumento: "INTERESSADO",
                              compararDocumentos:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouInteressadoDTO,
                              versaoCadastro: _vm.versaoCadastro
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isAreasPatrimoniais
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "imovel" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("Imóvel  ")
                      ]),
                      _vm.isPermuta
                        ? _c("informacoes-imovel-permuta", {
                            attrs: {
                              imovel: _vm.imovel,
                              compararImovelPermuta:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isInformacao
                        ? _c("informacoes-imovel-solicitacao", {
                            attrs: {
                              imovel: _vm.imovel,
                              compararImovelSolicitacao:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isAforamento
                        ? _c("informacoes-aforamento-imovel", {
                            attrs: {
                              imovel: _vm.imovel,
                              compararAforamentoImovel:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isTransferenciaDireitos
                        ? _c("informacoes-imovel-transferencia", {
                            attrs: {
                              imovel: _vm.imovel,
                              compararImovelTransferencia:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isCancelamento
                        ? _c("informacoes-imovel-cancelamento", {
                            attrs: {
                              imovel: _vm.imovel,
                              dadosProcessoFisico: _vm.dadosProcessoFisico,
                              compararImovelCancelamento:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO
                            }
                          })
                        : _vm._e(),
                      _vm.isReurbColetivo
                        ? _c("informacoes-reurb-coletivo-imovel", {
                            attrs: { imovel: _vm.imovel }
                          })
                        : _vm._e(),
                      _vm.imovel.documentos && _vm.imovel.documentos.length > 0
                        ? _c("listagem-documentos", {
                            attrs: {
                              documentos: _vm.imovel.documentos,
                              protocoloCadastroOriginal:
                                _vm.cadastroOriginal.protocolo,
                              ownerDocumento: "IMOVEL",
                              compararDocumentos:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes.mudouImovelDTO,
                              versaoCadastro: _vm.versaoCadastro
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isInformacao && !_vm.isCancelamento
                ? _c(
                    "el-tab-pane",
                    {
                      staticClass: "tab",
                      attrs: { name: "georreferenciamento" }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("Georreferenciamento  ")
                      ]),
                      _vm.abaAtiva === "georreferenciamento"
                        ? _c("app-resumo-geo", {
                            attrs: {
                              localizacao: _vm.processoRelatorio.geometria,
                              geo: _vm.georreferenciamento,
                              "id-mapa":
                                "mapaResumo" + _vm.georreferenciamento.id,
                              exibeDocumentos: false,
                              isVisualizarCadastro: true,
                              isGeoBeneficiario: false,
                              idCadastro: _vm.processo.numeroProtocolo,
                              isCadastroOff:
                                _vm.georreferenciamento.localizacoes &&
                                _vm.georreferenciamento.localizacoes.length >
                                  0 &&
                                !!_vm.georreferenciamento.localizacoes[0]
                                  .geometry,
                              idProcesso: _vm.idProcesso,
                              compararResumoGeo:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes
                                  .mudouGeorreferenciamentoDTO
                            }
                          })
                        : _vm._e(),
                      (_vm.georreferenciamento.documentos &&
                        _vm.interessado.documentos.length > 0) ||
                      (_vm.processo.documentosAutenticaveis &&
                        _vm.processo.documentosAutenticaveis.length > 0)
                        ? _c("listagem-documentos", {
                            attrs: {
                              documentos: _vm.georreferenciamento.documentos,
                              protocoloCadastroOriginal:
                                _vm.cadastroOriginal.protocolo,
                              documentosGeo:
                                _vm.processo.documentosAutenticaveis,
                              ownerDocumento: "GEO",
                              compararDocumentos:
                                _vm.compararRetificacoes &&
                                _vm.compararRetificacoes
                                  .mudouGeorreferenciamentoDTO,
                              versaoCadastro: _vm.versaoCadastro
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "termoCompromisso" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Termo de compromisso  ")
                  ]),
                  _c("informacoes-termo-compromisso", {
                    attrs: {
                      isCancelamentoClausulaResolutiva:
                        _vm.isCancelamentoClausulaResolutiva,
                      isReurb: _vm.isReurb
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a24db610", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a24db610","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/InformacoesCadastroOnline.vue
// module id = null
// module chunks = 